import React from 'react';

const ListIcon = () => {
  return (
    <svg
      width='18'
      height='10'
      viewBox='0 0 18 10'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M4 2V0H18V2H4ZM4 6V4H18V6H4ZM4 10V8H18V10H4ZM1 2C0.71667 2 0.479337 1.904 0.288004 1.712C0.0966702 1.52 0.000670115 1.28267 3.44827e-06 1C-0.000663218 0.717333 0.0953369 0.48 0.288004 0.288C0.48067 0.0960001 0.718003 0 1 0C1.282 0 1.51967 0.0960001 1.713 0.288C1.90634 0.48 2.002 0.717333 2 1C1.998 1.28267 1.902 1.52033 1.712 1.713C1.522 1.90567 1.28467 2.00133 1 2ZM1 6C0.71667 6 0.479337 5.904 0.288004 5.712C0.0966702 5.52 0.000670115 5.28267 3.44827e-06 5C-0.000663218 4.71733 0.0953369 4.48 0.288004 4.288C0.48067 4.096 0.718003 4 1 4C1.282 4 1.51967 4.096 1.713 4.288C1.90634 4.48 2.002 4.71733 2 5C1.998 5.28267 1.902 5.52033 1.712 5.713C1.522 5.90567 1.28467 6.00133 1 6ZM1 10C0.71667 10 0.479337 9.904 0.288004 9.712C0.0966702 9.52 0.000670115 9.28267 3.44827e-06 9C-0.000663218 8.71733 0.0953369 8.48 0.288004 8.288C0.48067 8.096 0.718003 8 1 8C1.282 8 1.51967 8.096 1.713 8.288C1.90634 8.48 2.002 8.71733 2 9C1.998 9.28267 1.902 9.52033 1.712 9.713C1.522 9.90567 1.28467 10.0013 1 10Z'
        fill='currentColor'
      />
    </svg>
  );
};

export default ListIcon;
